module.exports = __webpack_public_path__ + "img/responsibly.cd44c4dd.jpeg";